import { useState, useEffect } from 'react';

export default function BackToTop() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show button after scrolling down 400px
      setIsVisible(window.scrollY > 400);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <button
      onClick={scrollToTop}
      className={`fixed bottom-8 right-8 z-40 w-12 h-12 flex items-center justify-center rounded-full transition-all duration-300 cursor-pointer group ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
      }`}
      style={{
        background: 'linear-gradient(135deg, rgba(168,85,247,0.2) 0%, rgba(6,182,212,0.2) 100%)',
        backdropFilter: 'blur(12px)',
        border: '1px solid rgba(168,85,247,0.3)',
        boxShadow: '0 0 20px rgba(168,85,247,0.4), 0 0 40px rgba(6,182,212,0.2)',
      }}
      aria-label="Back to top"
    >
      {/* Hover glow effect */}
      <div 
        className="absolute inset-0 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"
        style={{
          background: 'linear-gradient(135deg, rgba(168,85,247,0.4) 0%, rgba(6,182,212,0.4) 100%)',
          filter: 'blur(8px)',
        }}
      />
      
      {/* Icon */}
      <i 
        className="ri-arrow-up-line text-xl relative z-10 transition-transform duration-300 group-hover:-translate-y-0.5"
        style={{
          background: 'linear-gradient(135deg, #a855f7, #06b6d4)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          filter: 'drop-shadow(0 0 8px rgba(168,85,247,0.8))',
        }}
      />
    </button>
  );
}